import { render, staticRenderFns } from "./cc-button.vue?vue&type=template&id=34a4979b&scoped=true"
import script from "./cc-button.vue?vue&type=script&lang=js"
export * from "./cc-button.vue?vue&type=script&lang=js"
import style0 from "./cc-button.vue?vue&type=style&index=0&id=34a4979b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a4979b",
  null
  
)

export default component.exports